import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import globalUserProfile from '../../../../../stores/global-user-profile';
import globalCourseStore from '../../../../../stores/global-course-store';

export const finishLectureAndRefreshOperation = async (
  programId: number,
  courseId: number,
  lectureId: number,
) => {
  try {
    await appApi.finishLecture(programId, courseId, lectureId);

    // Update user profile (for professors)
    await globalUserProfile.getUserProfile();

    // Reload course details to update lectures list
    const res = await appApi.getCourseDetails(programId, courseId);
    const currentCourse = globalCourseStore.getCurrentCourse();
    if (currentCourse?.details && res.data.body.details) {
      currentCourse.details.lectures = res.data.body.details.lectures;
    }

    toast.success('ההרצאה הסתיימה בהצלחה');
  } catch (error) {
    console.error('Failed to finish lecture:', error);
    toast.error('שגיאה בסיום ההרצאה. אנא נסה שוב.');
  }
};
